module.exports = __webpack_public_path__ + "assets/6eeb1856748226d81e138771420989a6.mp3";